
import mutations from './mutations'
import state from './state'

window.state = state
export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/section-product/index.js